import { useState } from 'react';
import { generatePath, Link, useNavigate } from 'react-router-dom';
import { ReactComponent as InfoIcon } from 'assets/icons/info.svg';
import Avatar from 'components/Avatar/Avatar';
import Badge from 'components/Badge/Badge';
import DeactivationInfoModal from 'components/DeactivationModals/DeactivationInfoModal';
import IconButton from 'components/IconButton/IconButton';
import TableCell from 'components/Table/TableCell';
import TableRow from 'components/Table/TableRow';
import AppRoutes from 'constants/AppRoutes';
import { COMPANY_STATUSES } from 'constants/company';
import { EXTEND_DATE_FORMAT } from 'constants/general';
import { COMPANY_STATUS } from 'constants/interfaces';
import dayjs from 'dayjs';

import ClientsTableActions from '../ClientsTableActions/ClientsTableActions';

import type IClientsTableRow from '../../interfaces/IClientsTableRow';

import styles from './scss/ClientsTableRow.module.scss';

function ClientsTableRow({ company }: IClientsTableRow) {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const onHandleEdit = () => {
    navigate(generatePath(AppRoutes.companyInfo, { clientId: String(company.id) }));
  };

  return (
    <TableRow>
      <TableCell className={styles.nameCell}>
        <Link
          to={generatePath(AppRoutes.clientProfile, { clientId: String(company.id) })}
          className={styles.client}
        >
          <Avatar
            src={company.uiConfiguration?.companyLogo}
            alt={company.name}
          />
          <p className={styles.clientName}>
            {company.name}
          </p>
        </Link>
      </TableCell>
      <TableCell>
        {dayjs(company.createdAt).format(EXTEND_DATE_FORMAT)}
      </TableCell>
      <TableCell>
        <div className={styles.status}>
          <Badge
            status={COMPANY_STATUSES[company.status].label}
            color={COMPANY_STATUSES[company.status].color}
            textColor={COMPANY_STATUSES[company.status].textColor}

          />
          {company.status === COMPANY_STATUS.deactivated ? (
            <IconButton
              className={styles.info}
              size="small"
              icon={<InfoIcon />}
              onClick={() => setIsModalOpen(true)}
              isWarning
            />
          ) : null}
        </div>

        <DeactivationInfoModal
          open={isModalOpen}
          deactivationInfo={company.latestDeactivation}
          onClose={() => setIsModalOpen(false)}
        />
      </TableCell>
      <TableCell>
        {company.companyAdminUsers.length ? company.companyAdminUsers.map((admin) => (
          <p key={admin.id} className={styles.adminNames}>{`${admin.firstName} ${admin.lastName}`}</p>
        )) : '-'}
      </TableCell>
      <TableCell>
        <ClientsTableActions
          companyId={company.id}
          status={company.status}
          onHandleEdit={onHandleEdit}
        />
      </TableCell>
    </TableRow>
  );
}

export default ClientsTableRow;
